// extracted by mini-css-extract-plugin
export var editButton = "_mi-0";